export const DOCUMENT_ICON = Object.freeze({
  ANNOTATE: "annotation-filled",
  ANNOTATE_LINE: "annotation-line",
  IN_MEETING: "pencil-user-square",
  IN_MEETING_LINE: "pencil-user-square-outline",
  NOTARIZATION: "notarize-badge",
  PROOFING: "user",
  WET_SIGN: "wetsign-on",
  WET_SIGN_LINE: "wetsign-off",
  WITNESS: "witness-filled",
  WITNESS_LINE: "witness-line",
  EVAULT: "lock-shield",
});
